import { NavLink } from 'react-router-dom'
import { ReactComponent as Notify } from '../../assets/notify.svg'
import { Container } from './styles'

export const HeadAdmin = () => {
  return (
    <Container>
      <div>
        <h1>Administração</h1>
        <div>
          <span>01</span>
          <Notify />
        </div>
      </div>

      <div>
        <div>
          <NavLink to='/admin/order' end>
            Pedidos
          </NavLink>
          <NavLink to='/admin/register-snack' end>
            Cadastrar
          </NavLink>
        </div>
      </div>
    </Container>
  )
}
